import React from 'react';
import { motion } from 'framer-motion';
import Footer from './Footer';
import Header from './Header';
import '../css/AboutPage.css';
import { Link } from "react-router-dom";


const AboutPage = () => {
  return (
    <div>
      <Header />

      <div className="about-container">
        <motion.h2
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          className="about-title"
        >
          About SmartKids Prep Academy
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          className="about-text"
        >
          Welcome to <strong>SmartKids Prep Academy</strong>, a comprehensive platform designed to help elementary school students prepare for important standardized tests such as IAAT, NNAT, and COGAT. Our website provides thousands of test questions and practice materials, making it an excellent tool for preparation.
        </motion.p>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          className="about-features"
        >
          <motion.p className="about-text">
            SmartKidsPrep.com offers a variety of features to help students practice:
          </motion.p>
          <ul className="about-list">
            <li>Take practice tests directly on the website using our online tool.</li>
            <li>Generate a PDF of the question paper for a paper-based test experience.</li>
            <li>Access thousands of test questions for comprehensive preparation.</li>
          </ul>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          className="about-features"
        >
          <motion.p className="about-text">
            All of these features are completely free! To get started, simply create an account by logging in using one of the following methods:
          </motion.p>
          <ul className="about-list">
            <li>Google (Gmail)</li>
            <li>Facebook</li>
            <li>Amazon</li>
          </ul>
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          className="about-text"
        >
          Once you’re logged in, you can start practicing right away, track your progress, and take full advantage of all the resources SmartKidsPrep.com has to offer. Prepare confidently, and boost your chances for success!
        </motion.p>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          className="about-call-to-action"
        >
          <h3 className="call-to-action-title">Get Started Today!</h3>
          <p><Link to="/account" className="cta-link">Log in now</Link> now to begin your preparation journey with SmartKids Prep!</p>
        </motion.div>
      </div>

      <Footer />
    </div>
  );
};

export default AboutPage;
